import { UniRequest } from "@uniframe/toolkit";
import { isApp } from './browser';
import { getUserToken, removeToken, setToken } from './token';
import { showComplianceWall } from './uniframe';
import { transformResponse } from "./webapi/utils";

const uniRequest = new UniRequest({
  credentials: "include",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    platform: isApp() ? "h5" : "pc",
  },
});

uniRequest.addInstanceRequestInterceptors([
  async (url, options) => {
    // 用户 Token
    const token = await getUserToken();
    if (token) {
      options['headers'].usertoken = token;
    }
    return {
      url,
      options,
    };
  },
]);

uniRequest.addInstanceResponseInterceptors([
  async (response, _, operations) => {
    // always clone the response before working on it
    try {
      const clonedResponse = response.clone();
      const res = await clonedResponse.json();
      const data = transformResponse(res);

      if (!data) {
        return Promise.reject(
          operations.createResponseError("Non Response!", undefined)
        );
      }

      // 登录状态有啥问题时直接跳转到登录页
      if ([10007, 33003, 10009, 30000].includes(data.ret_code)) {
        if (!response?.url?.includes?.('/v2/private/user/profile')) {
          operations.clearOneCache();
        }
        removeToken();
      }

      // 续 Token
      if (data.token) {
        setToken(data.token);
        // reportToken('ajax_set', res);
      }

      // 合规墙 - （用户没有KYC || 本地区不支持此服务）就弹出相关弹窗
      if (data.ret_code === 10024) {
        const { ret_code: retCode, result } = data;
        // 阻止toast弹出信息
        data.message = '';
        showComplianceWall(retCode, result);
      }

      return response;
    } catch (err) {
      return Promise.reject(err);
    }
  },
]);

export {
  uniRequest,
};
